import React from 'react'
import { StyledMasonryTileTitle, StyledTitle } from '../../styles/MasonryStyles'
import { SxProps } from '@mui/system'
import { useTheme } from '@mui/material'

type MasonryTileTitleProps = {
  title: string
  icon?: React.ElementType
  sx?: SxProps
}

const MasonryTileTitle = ({ title, icon, sx }: MasonryTileTitleProps) => {
  const theme = useTheme()

  return (
    <StyledMasonryTileTitle sx={sx}>
      {icon && React.createElement(icon, { sx: { width: 28, height: 28 } })}
      <StyledTitle component="h2" variant="h5" sx={{ textTransform: 'capitalize' }} theme={theme}>
        {title}
      </StyledTitle>
    </StyledMasonryTileTitle>
  )
}

export default MasonryTileTitle